import React from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import WhoWeAre from "../components/WhoWeAre";
import PropertySearch from "../components/PropertySearch";
import ServicesSection from "../components/ServicesSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <WhoWeAre />
      <PropertySearch />
      <ServicesSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;